export { SpaCategoryListTemplate } from './SpaCategoryListTemplate';
export type {
  SpaCategoryItem,
  SpaCategoryListTemplateProps,
} from './SpaCategoryListTemplate.types';
